/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import PageHeadline from "../../PageHeadline/PageHeadline";
import PageContentContainer from "../../Container/PageContentContainer";
import ScanDocument from "../../ScanDocument/ScanDocument";

export default function ScanDocumentPage() {
  if (import.meta.env.VITE_DEPLOYMENT === "production") {
    return null;
  }

  return (
    <PageContentContainer size={"tiny"}>
      <PageHeadline main="Dokument für Testing scannen" />
      <ScanDocument />
    </PageContentContainer>
  );
}
